// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3nrgm","box":"WorkspacesBox_box__1vfAK","node":"WorkspacesBox_node__2-uQW"};